import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Buttons, ModalContext, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import StorageService from 'Services/storage';
import { showModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetPreviousYearsPercentage } from 'Containers/PreviousYears/hooks';
import { PREVIOUS_YEAR_STORAGE_KEY } from 'Containers/PreviousYears/types';
import { createURL } from 'Containers/Plans/utils';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { EfirmaInfo } from 'Components/Modal/components';
import { PAYMENT_METHOD_PA_MODAL } from 'Constants/modals';
import { routes } from 'Constants/routes';
import { UpsellingAAnfo } from '../UpsellingAAnfo';
import UpsellingAASlider from '../UpsellingAASlider';
import * as Styled from './styles';

const PreviousYearsCheckout = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const [amount, setAmount] = useState<number>(0);
  const dispatch = useDispatch();
  const { showModal } = useContext(ModalContext);
  const { mutate, isLoading, data } = useFetchGetPreviousYearsPercentage();

  useEffect(() => {
    const amountPending = StorageService.getItem(PREVIOUS_YEAR_STORAGE_KEY);
    if (amountPending) {
      setAmount(Number(amountPending));
      mutate({ amount: Number(amountPending) * 100 });
    }
  }, []);

  const handleClick = (): void => {
    dispatch(
      showModalAction({
        options: {
          type: PAYMENT_METHOD_PA_MODAL,
          data: {
            successUrl: createURL(routes.PREVIOUS_YEARS_WORKING),
            cancelUrl: createURL(routes.PREVIOUS_YEARS_CHECKOUT),
            upsellingProps: {
              price: {
                amount: amount * 100,
              },
              pendingAmount: amount,
            },
          },
        },
      })
    );
  };

  const hanldeShowModal = (): void => {
    showModal({
      comp: <EfirmaInfo isPayLater />,
    });
  };

  return (
    <OneColLayout>
      <Styled.Container direction="column" fullHeight fullWidth align="center" gap="dimension_24">
        {isLoading ? (
          <Spinner size="M" align="center" justify="center" />
        ) : (
          <>
            <Text type="paragraphs" color="dark" size="XL_XL_S">
              {t(`Upselling.PreviousYears.title`)}
            </Text>
            {data && <UpsellingAAnfo data={data?.data?.item} />}
            <Styled.ButtonContainer direction="column" fullWidth gap="dimension_24">
              <Buttons.Tiny label={t(`Upselling.tiny.button`)} onClick={hanldeShowModal} />
              <Buttons.Classic
                label={t(`Upselling.PreviousYears.button`)}
                mode="expert"
                size="m"
                fullWidth
                onClick={handleClick}
              />
            </Styled.ButtonContainer>
            <UpsellingAASlider />
          </>
        )}
      </Styled.Container>
    </OneColLayout>
  );
};

export default PreviousYearsCheckout;
